export default "__VITE_ASSET__CpJQRuCI__"